import React from 'react'
import {Link} from "react-router-dom"
import {MoneyNav} from "../elements/MoneyNav"
import {
    hideHandler,
    filterMoneyHandler,
    getValuesOfNames,
    getMoneyPathBack,
    getGlobalMoneyObject,
    expandCollapseHandler,
    getValuesAllNames,
    sortDate,
} from "../functions"

export class YearDetailClass extends React.Component {

    render() {

        const {
            lang,
            dataYear,
            expandIncome,
            setExpandIncome,
            expandExpense,
            setExpandExpense,
            setPreTotalInc,
            preTotalInc,
            setPreTotalExp,
            preTotalExp,
            pathBack
        } = this.props

        const currency = dataYear.currency,
            months = dataYear['months'],
            incomes = [],
            expenses = [],
            arrIncomes = [],
            arrIncomesAll = [],
            arrIncomesCategories = [],
            arrExpenses = [],
            arrExpensesAll = [],
            arrExpensesCategories = []

        // expensesPayment = [],
        // expensesPurchase = [],
        // arrIncomesTotalPayment = [],
        // arrIncomesTotalPurchase = [],
        // arrExpensesTotalPayment = [],
        // arrExpensesTotalPurchase = [],
        // arrBalancesMonthPayment = [],
        // arrBalancesMonthPurchase = []

        if (months) {
            for (const m in months) {
                const month = months[m]
                for (const f in month) {
                    if (f === 'income') {
                        incomes.push(month[f])
                    }
                    if (f === 'expensePurchase') {
                        expenses.push(month[f])
                        // expensesPurchase.push(month[f])
                    }
                    // if (f === 'expensePayment') {
                    //     expensesPayment.push(month[f])
                    // }
                    // if (f === 'incomesMonthTotalPayment') {
                    //     arrIncomesTotalPayment.push(month[f])
                    // }
                    // if (f === 'incomesMonthTotalPurchase') {
                    //     arrIncomesTotalPurchase.push(month[f])
                    // }
                    // if (f === 'expensesMonthTotalPayment') {
                    //     arrExpensesTotalPayment.push(month[f])
                    // }
                    // if (f === 'expensesMonthTotalPurchase') {
                    //     arrExpensesTotalPurchase.push(month[f])
                    // }
                    // if (f === 'balanceMonthPayment') {
                    //     arrBalancesMonthPayment.push(month[f])
                    // }
                    // if (f === 'balanceMonthPurchase') {
                    //     arrBalancesMonthPurchase.push(month[f])
                    // }
                }
            }
        }

        if (incomes) {
            for (const inc in incomes) {
                const value = incomes[inc]
                arrIncomes.push([inc, value])
            }
        }
        const totalIncomeValue = dataYear['incomesTotal']
        const totalExpensesValue = dataYear['expensesTotal']
        const yearBalance = dataYear['balance']

        if (expenses) {
            for (const exp in expenses) {
                const value = expenses[exp]
                arrExpenses.push([exp, value])
            }
        }

        getValuesOfNames(arrIncomes, arrIncomesCategories)
        getValuesOfNames(arrExpenses, arrExpensesCategories)

        getValuesAllNames(arrIncomes, arrIncomesAll)
        getValuesAllNames(arrExpenses, arrExpensesAll)

        arrIncomesAll.sort((a, b) => {
            return sortDate(a, b, 5)
        })
        arrExpensesAll.sort((a, b) => {
            return sortDate(a, b, 5)
        })

        arrIncomesAll.reverse()
        arrExpensesAll.reverse()

        const dataNav = {
            pathBack: pathBack,
            isMain: true,
            isMoney: true,
            isSetting: false,
            isAddIncome: true,
            isAddCredit: false,
            isAddPurchase: true,
            isSelectPeriod: true,
            currency: getGlobalMoneyObject()['currency']
        }

        return (
            <>
                <MoneyNav dataNav={dataNav}/>
                <div className={"mt-3 col col-sm-11 col-lg-12 col-xl-9 m-auto"}>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className={'col col-12 d-flex justify-content-between mb-3'}>
                                <div className={'col col-6 d-flex justify-content-end'}>
                                    <h4 className={"card-title m-auto"}>{`${dataYear.year}`}</h4>
                                </div>
                                <div className={'col col-5 d-flex justify-content-end'}>
                                    <h5 className={"card-title m-auto pe-2"}>{lang.body.moneyPage.main.balance}&nbsp;{yearBalance}</h5>
                                </div>
                                <Link to={getMoneyPathBack()}
                                      id={"button-close-year"}
                                      className={"col col-1 btn-close fs-3 m-0"}
                                      aria-label={"Close"}>
                                </Link>
                            </div>

                            <div className={`year-income-expense m-1`}>

                                {/* Годовые Доходы */}
                                <div className={'col border border-3 rounded-2 m-2 ps-2 pe-2 pt-3 pb-3'}>
                                    <div id={'div-incomes'} className={'col align-self-end'}>
                                        <div className={'filter row col w-50 d-flex flex-nowrap mb-2'}>
                                            <button className={'btn col col-1 ms-3'}
                                                    onClick={() => {
                                                        expandCollapseHandler('btn-income-expand-collapse', 'income', setExpandIncome, setExpandExpense)
                                                    }}>
                                                <i id={'btn-income-expand-collapse'}
                                                   className={"fa-solid fa-chevron-down fs-3 opacity-75 p-0"}/>
                                            </button>
                                            <h4 className={"card-title text-center m-1 mb-3 pb-1"}>{lang.body.moneyPage.main.incomes}</h4>
                                            {!expandIncome && <input
                                                autoComplete={"off"}
                                                id={'incomes-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrIncomesCategories, 'year')
                                                    const resultArrNames = filterRes.names
                                                    hideHandler(resultArrNames, 'div-incomes', 'year')
                                                    setPreTotalInc(filterRes.preTotal)
                                                    if (preTotalInc > 0) {
                                                        document.querySelector('#pre-total-incomes').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-incomes').classList.add('d-none')
                                                    }
                                                }}/>}
                                            {expandIncome && <input
                                                autoComplete={"off"}
                                                id={'incomes-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrIncomesAll, 'year-all')
                                                    const resultArrNames = filterRes.names
                                                    hideHandler(resultArrNames, 'div-incomes', 'year')
                                                    setPreTotalInc(filterRes.preTotal)
                                                    if (preTotalInc > 0) {
                                                        document.querySelector('#pre-total-incomes').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-incomes').classList.add('d-none')
                                                    }
                                                }}/>}
                                        </div>

                                        {!expandIncome && arrIncomesCategories.map((category, index) => {
                                            const nameCat = category[0]
                                            const value = category[1].toFixed(2)
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`incomes-row-${index}`} className={'row m-1'} key={index}>
                                                        <div id={`incomes-div-${index}`}
                                                             className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                            <h6 id={`incomes-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`incomes-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}

                                        {expandIncome && arrIncomesAll.map((category, index) => {
                                            const dateCat = category[0]
                                            const nameCat = category[1]
                                            const value = category[3].toFixed(2)
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`income-row-${index}`}
                                                         className={'row m-1 mt-3'}
                                                         key={index}>
                                                        <div id={`income-div-date-${index}`}
                                                             className={'d-flex justify-content-start'}>
                                                            <i className={"mt-1 me-2 opacity-50 fa-solid fa-money-check-dollar"}/>
                                                            <p id={`income-date-${index}-payment`}
                                                               className={'m-0 opacity-50'}>{dateCat}</p>
                                                            <p id={`income-cardId-${index}`}
                                                               className={'m-0'}>{''}</p>
                                                        </div>
                                                        <div id={`income-div-${index}`}
                                                             className={'col col-11 d-flex justify-content-between border-bottom'}>
                                                            <h6 id={`income-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`income-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}

                                    </div>

                                    <div id={'pre-total-incomes'} className={'filter row m-1 mt-4'}>
                                        <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                            <h6 className={'m-0 text-primary'}>{'Итого по фильтру'}</h6>
                                            <p className={'m-0'}>{`${preTotalInc} (${currency})`}</p>
                                        </div>
                                    </div>
                                    <div id={'all-incomes-year'} className={'filter row m-1 mt-4'}>
                                        <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                            <h6 className={'m-0 text-success'}>{'Всего доходов в году'}</h6>
                                            <p className={'m-0'}>{`${totalIncomeValue} (${currency})`}</p>
                                        </div>
                                    </div>

                                </div>

                                {/* Годовые Расходы */}
                                <div className={'col border border-3 rounded-2 m-2 ps-2 pe-2 pt-3 pb-3'}>
                                    <div id={'div-expenses'} className={'add-expense ps-2 pe-2'}>
                                        <div className={'filter row col w-50 d-flex flex-nowrap mb-2'}>
                                            <button className={'btn col col-1 ms-3'}
                                                    onClick={() => {
                                                        expandCollapseHandler('btn-expense-expand-collapse', 'expense', setExpandIncome, setExpandExpense)
                                                    }}>
                                                <i id={'btn-expense-expand-collapse'}
                                                   className={"fa-solid fa-chevron-down fs-3 opacity-75 p-0"}/>
                                            </button>
                                            <h4 className={"card-title text-center m-1 mb-3 pb-1"}>{lang.body.moneyPage.main.expenses}</h4>
                                            {!expandExpense && <input
                                                autoComplete={'off'}
                                                id={'expenses-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrExpensesCategories, 'year')
                                                    const resultArrNames = filterRes.names
                                                    hideHandler(resultArrNames, 'div-expenses', 'year')
                                                    setPreTotalExp(filterRes.preTotal)
                                                    if (preTotalExp > 0) {
                                                        document.querySelector('#pre-total-expenses').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-expenses').classList.add('d-none')
                                                    }
                                                }}/>}
                                            {expandExpense && <input
                                                autoComplete={'off'}
                                                id={'expenses-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrExpensesAll, 'year-all')
                                                    const resultArrNames = filterRes.names
                                                    hideHandler(resultArrNames, 'div-expenses', 'year')
                                                    setPreTotalExp(filterRes.preTotal)
                                                    if (preTotalExp > 0) {
                                                        document.querySelector('#pre-total-expenses').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-expenses').classList.add('d-none')
                                                    }
                                                }}/>}
                                        </div>

                                        {!expandExpense && arrExpensesCategories.map((category, index) => {
                                            const nameCat = category[0]
                                            const value = category[1].toFixed(2)
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`expenses-row-${index}`} className={'row m-1'} key={index}>
                                                        <div id={`expenses-div-${index}`}
                                                             className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                            <h6 id={`expenses-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`expenses-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}

                                        {expandExpense && arrExpensesAll.map((category, index) => {
                                            const datePur = category[0]
                                            const nameCat = category[1]
                                            const value = category[3].toFixed(2)
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`expense-row-${index}`} className={'row m-1 mt-3'}
                                                         key={index}>
                                                        <div id={`expense-div-date-${index}`}
                                                             className={'d-flex justify-content-start'}
                                                             style={{width: "100%"}}>
                                                            <i className={"mt-1 me-2 opacity-50 fa-solid fa-bag-shopping"}/>
                                                            <p id={`expense-date-${index}-purchase`}
                                                               className={'m-0 me-4 opacity-50'}>{`${datePur}`}</p>
                                                            <p id={`expense-cardId-${index}`}
                                                               className={'m-0'}>{''}</p>
                                                        </div>
                                                        <div id={`expense-div-${index}`}
                                                             className={'col col-11 d-flex justify-content-between border-3 border-bottom'}>
                                                            <h6 id={`expense-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`expense-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}

                                        <div id={'pre-total-expenses'} className={'filter row m-1 mt-4'}>
                                            <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                <h6 className={'m-0 text-primary'}>{'Итого по фильтру'}</h6>
                                                <p className={'m-0'}>{`${preTotalExp} (${currency})`}</p>
                                            </div>
                                        </div>
                                        <div id={'all-expenses-year'} className={'filter row m-1 mt-4'}>
                                            <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                <h6 className={'m-0 text-danger'}>{'Всего расходов в году'}</h6>
                                                <p className={'m-0'}>{`${totalExpensesValue} (${currency})`}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
